<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <Tab />
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="tenantId"
                placeholder="商户ID"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in tabList"
                  :key="item.id"
                  :label="item.tenantName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">订单平仓日期</div> -->
            <div class="ipt">
              <el-date-picker
                size="mini"
                v-model="value1"
                type="daterange"
                align="right"
                format="yyyy-MM-dd"
                value-format="timestamp"
                unlink-panels
                clearable
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </div>

          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>

          <!-- <div class="item">
            <a @click="getExcel" target="_blank">导出Excel</a>
          </div> -->
        </div>
      </div>
      <div class="pl_total_box total_box">
        <div class="pl_total total">
          <span>累计参与用户</span>
          <span></span>
          <span>{{ userTotalCount || 0 }}</span>
        </div>
        <div class="pl_total total">
          <span>当前参与人数</span>
          <span></span>
          <span>{{ userJoinCount || 0 }}</span>
        </div>

        <div class="pl_total total">
          <span>累计奖励红包</span>
          <span></span>
          <span>{{ incentiveAmount || 0 }}</span>
          <span>USDT</span>
        </div>

        <div class="pl_total total">
          <span>已提现金额</span>
          <span></span>
          <span>{{ extractedAmount || 0 }}</span>
          <span>USDT</span>
        </div>
        <div class="pl_total total">
          <span>未提现金额</span>
          <span></span>
          <span>{{ unExtractedAmount || 0 }}</span>
          <span>USDT</span>
        </div>
        <div class="pl_total total">
          <span>累计奖励奖券</span>
          <span></span>
          <span>{{ inventiveLotteryCount || 0 }}</span>
        </div>
        <div class="pl_total total">
          <span>已使用奖券</span>
          <span></span>
          <span>{{ usedLotteryCount || 0 }}</span>
        </div>
        <!-- <div class="pl_total total">
          <span>已过期奖券</span>
          <span></span>
          <span>{{ totalProfit || 0 }}</span>
        </div> -->
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import './store'
import UserList from './components/list'
import Tab from '../components/Tab'
import Add from './components/add'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import moment from 'moment'
import userUid from '@/assets/input/userUid.png'
import invite from '@/assets/input/invite.png'
import channel from '@/assets/input/channel.png'
import api from '../api'

import Del from './components/del'
export default {
  name: 'ContactHistory',
  components: {
    UserList,
    Tab,
    Del,
    Add,
  },
  data() {
    return {
      invite,
      channel,
      userUid,
      type: 1,
      dialogVisible: false,
      totalProfit: '',
      tenantId: '',
      tabList: [],
      value1: [
        moment().subtract(7, 'days').startOf('day').valueOf(),
        moment().valueOf(),
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapState('topPartner', ['topPartner']),
    ...mapGetters('statistics', [
      'userTotalCount',
      'userJoinCount',
      'incentiveAmount',
      'extractedAmount',
      'unExtractedAmount',
      'inventiveLotteryCount',
      'usedLotteryCount',
    ]),
    ...mapState('statistics', [
      'totalRealizedProfit',
      'totalFee',
      'pagination',
      'symbolList',
      'orderBy',
    ]),
  },
  methods: {
    ...mapActions('statistics', ['getHistory', 'exportExcel', 'getSymbolList']),

    ...mapMutations('statistics', ['setOrderBy', 'setDelVisible']),
    showDel() {
      this.setDelVisible(true)
    },

    refreshList(data = {}) {
      this.getHistory({
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.value1[1] : '',
        ...this.pagination,
        ...data,
      })
    },
    getExcel() {
      this.exportExcel({
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.value1[1] : '',
        ...this.pagination,
      }).then((res) => {
        const link = document.createElement('a')
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
        link.style.display = 'none'
        // 设置连接
        link.href = URL.createObjectURL(blob) //将文件流转化为blob地址
        console.log('link-href', link.href)
        link.download = '历史仓位记录'
        document.body.appendChild(link)
        // 模拟点击事件
        link.click() //设置点击事件
      })
    },

    handleSearch() {
      if (!this.tenantId) {
        this.$message.warning('请输入商户ID进行查询')
        return
      }
      this.getHistory({
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.value1[1] : '',
        ...this.pagination,
        tenantId: this.tenantId,

        page: 1,
      })
    },
    handleSave() {},
    closeDialog() {
      this.dialogVisible = false
    },
    onOpen() {},
    onClose() {
      this.$refs['elForm'].resetFields()
      this.dialogVisible = false
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs['elForm'].resetFields()
      this.dialogVisible = false
    },
    // clearSort() {
    //   this.setOrderBy(null)
    //   this.$refs.table.doSort('', '')
    // },
  },
  created() {
    this.$message.warning('请输入商户ID进行查询')
    api.getTenantList().then((res) => {
      if (res.code == 0) {
        const { data } = res
        this.tabList = data
      }
    })
    // this.getHistory({
    //   startTime: this.value1 ? this.value1[0] : '',
    //   endTime: this.value1 ? this.value1[1] : '',

    //   ...this.pagination,
    // })
  },
}
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
<style lang="less">
.total_box {
  flex-wrap: wrap;
  .total {
    margin-bottom: 12px;
  }
}
</style>
